import React, { useEffect,useState } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import {connect} from "react-redux";
import Authentication from "../../../Models/Authentication";

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

const TopbarProfile = ({dispatch,user}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const am=new Authentication();

  useEffect(()=>{

  },[user]);

  return (
    <div className="topbar__profile">
      <button type="button" className="topbar__avatar" onClick={setIsCollapsed}>
        <img className="topbar__avatar-img" src={Ava} alt="avatar" />
        <p className="topbar__avatar-name">{user!== null ? user.u_first : null}</p>
        <DownIcon className="topbar__icon" />
      </button>
      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
            <button type="button" className="topbar__button topbar__link topbar__button--desktop" onClick={am.logout}>
                <p className="topbar__link-title">Logout</p>
            </button>
        </div>
      </Collapse>
    </div>
  );
};

export default connect(state => ({
    user : state.user.main
}))(TopbarProfile);
